import axios from 'axios/index'
import api from './api/menu.api'

export default {
  /**
   * 获取菜单列表
   */
  getMenuList(params){
    return axios.post(api.getMenuList, params)
	},
  /**
   * 添加，编辑 菜单
   */
  editMenu(params){
    return axios.post(api.editMenu, params)
  },
  /**
   * 添加，编辑 按钮
   */
  editButton(params){
    return axios.post(api.editButton, params)
  },
  /**
   *  删除菜单，按钮
   */
  deleteMenu(params){
    return axios.post(api.deleteMenu, params)
  }
}


